exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group label.control-label {\n    font-size: 16px;\n    line-height: 1.07143;\n    color: #AAAAAA;\n    font-weight: 600;\n    margin: 16px 0 0 0;\n    padding-bottom:8px; \n}\n.form-group {\n    margin-bottom: 0px;\n}\ninput.survey_file {\n    max-width: 132px;\n    margin-top: 5px;\n}\ninput.survey_file + label {\n    border: 1px solid gray;\n    padding: 5px 12px;\n    color: #333;\n    position: relative;\n    top: 8px;\n}\n.form-group:first-child label.control-label.col-sm-4:first-child {\n    padding-left: 15px;\n}\nlabel.control-label.col-sm-4 {\n    padding-left: 0px;\n}\n.form-group .col-sm-6 label.control-label.col-sm-4 {\n    margin-top: 8px;\n    padding-bottom: 7px;\n    width: 200px;\n}\n.form-group .col-sm-6 {\n    min-height: 95px;\n}\nbutton.btn-upload{\n    border-radius: 0px;\n    margin-top: 10px;\n}\n.survey_file {\n    display: none;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/admin-log-report-list/admin-log-report-list.component.css
// module id = ../../../../../src/app/dashboard/admin-log-report-list/admin-log-report-list.component.css
// module chunks = main